import { render } from "./staffUserManage.vue?vue&type=template&id=721efc8c"
import script from "./staffUserManage.vue?vue&type=script&lang=jsx"
export * from "./staffUserManage.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__